import { Route } from '@angular/router';
import { mgsExclusionRoleGuard } from '../../mgs-guards';
import { DIENSTLEISTUNG_PATH, DIENSTLEISTUNG_TITLE } from '../../mgs-path-defs';
import {
  MgsRole,
  ROLE_MGS_ABRECHNUNG,
  ROLE_MGS_ARZT,
  ROLE_MGS_BUCHUNG,
  ROLE_MGS_KIDS,
  ROLE_MGS_SPOWI,
  ROLE_MGS_USER_FOR_KIDS_TERMIN
} from '@mng/mgs-lib';

export const dienstleistungLadenRolesForExclusion: MgsRole[] = [
  ROLE_MGS_KIDS,
  ROLE_MGS_USER_FOR_KIDS_TERMIN,
  ROLE_MGS_ABRECHNUNG,
  ROLE_MGS_BUCHUNG,
  ROLE_MGS_SPOWI,
  ROLE_MGS_ARZT
];

export const dienstleistungLadenRoute: Route = {
  path: DIENSTLEISTUNG_PATH,
  loadComponent: () => import('./dienstleistung-laden.component'),
  canActivate: [mgsExclusionRoleGuard(dienstleistungLadenRolesForExclusion)],
  title: DIENSTLEISTUNG_TITLE
};
